import { Text } from '@zillow/constellation-10';

import type { ComponentProps } from 'react';

// Constellation Text renders its own color, which means CMS hero wrappers
// (e.g. `.jlvSHa`) can bleed their forced color into it. Use InheritText
// inside CMS-rendered blocks so the text follows its parent's color instead.
const InheritText = ({ css, ...rest }: ComponentProps<typeof Text>) => (
  <Text css={{ color: 'inherit', ...css }} {...rest} />
);

export default InheritText;
